import { Dispatch, ThunkAction } from '../../../../types/actions';
import { showBoardLimitSnackbarAndEvent } from '../../../../store/model/effects/showBoardLimitSnackbarAndEvent';
import { SegmentUserTypeOption } from '../../../../middlewares/segment/trackEntities/userEvents';
import { isBoardCardsLimitReached } from '../../../../store/model/selectors/isBoardCardsLimitReached';
import { IGetState } from '../../../../types/types';
import { getActiveBoardId } from '../../../../store/model/selectors/getActiveBoardId';

export const showBoardLimitSnackbarIfNeeded = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        const state = getState();
        if (isBoardCardsLimitReached(state, getActiveBoardId(state), 0)) {
            dispatch(showBoardLimitSnackbarAndEvent(SegmentUserTypeOption.EDIT_TRY));
        }
    };
    return action;
};
